// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19he7","newExpiryDate":"styles_newExpiryDate__ZPoqr","footer":"styles_footer__28tCU"};